/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55967492
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as ProgramsList from '@components/LibraryProgramsList';

class List extends React.PureComponent {
    handleToggle = (e) => () => {
        this.props.onToggle(e);
    };

    render() {
        const { data, role } = this.props;

        return (
            <>
                <div className="d-flex py-2">
                    <div className="d-flex-6 dsl-m12">Health Plan</div>
                    <div className="d-flex-1 dsl-m12">Goals</div>
                    <div className="d-flex-1 dsl-m12">Courses</div>
                    <div className="d-flex-1 dsl-m12">Assigned</div>
                </div>
                {data.map((item, index) => (
                    <ProgramsList.ClosedList
                        key={`${item.id}-${index}`}
                        role={role}
                        name={item.title}
                        modules={item.data.assigned}
                        description={item.data.description}
                        quotasCount={item.data.quota_count}
                        courseCount={item.data.course_count}
                        type="careers"
                        published={item.published}
                        thumbnail={item.data.thumb_url}
                        onToggle={this.handleToggle(item.id)}
                        onChange={(e) => this.props.onChange(e, item)}
                    />
                ))}
            </>
        );
    }
}

List.propTypes = {
    role: PropTypes.number,
    data: PropTypes.array,
    onToggle: PropTypes.func,
    onModal: PropTypes.func,
};

List.defaultProps = {
    role: 1,
    data: [],
    onToggle: () => {},
    onModal: () => {},
};

export default List;
